import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import type { Product } from "@/mocks/products";
import ProductCard from "./ProductCard";

interface ProductRailProps {
  title: string;
  kicker?: string;
  products: Product[];
  moreHref?: string;
}

// Título da seção à esquerda, "Ver tudo" à direita e vitrine de quatro peças com setas.
export default function ProductRail({ title, kicker, products, moreHref }: ProductRailProps) {
  const track = useRef<HTMLDivElement>(null);
  if (products.length === 0) return null;
  const scroll = (direction: number) => track.current?.scrollBy({ left: direction * track.current.clientWidth, behavior: "smooth" });
  return (
    <section className="bz-shelf" aria-label={title}>
      <header className="bz-shelf-head">
        <div>
          {kicker && <p>{kicker}</p>}
          <h2>{title}</h2>
        </div>
        {moreHref && <Link to={moreHref}>Ver tudo <ArrowRight size={15} strokeWidth={1.75} aria-hidden="true" /></Link>}
      </header>
      <div className="bz-rail-wrap">
        <button type="button" className="bz-rail-arrow prev" aria-label="Anterior" onClick={() => scroll(-1)}><ChevronLeft size={18} strokeWidth={1.5} aria-hidden="true" /></button>
        <div className="bz-rail" ref={track} tabIndex={0} aria-label={`${title}, deslize para ver mais`}>
          {products.map((product) => <ProductCard key={product.id} product={product} />)}
        </div>
        <button type="button" className="bz-rail-arrow next" aria-label="Próximo" onClick={() => scroll(1)}><ChevronRight size={18} strokeWidth={1.5} aria-hidden="true" /></button>
      </div>
    </section>
  );
}
